import { useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import API from "../Network/API";
import { useDispatch, useSelector } from "react-redux";
import Agent from "../Network/Agent";
import { useEffect } from "react";
import { USER_FETCH_START } from "../Reducer/profileSlice";
import { USER_LOGGED_IN } from "../Reducer/authSlice";
import DashboardSettingModel from "../Models/DashboardSettingModel";

import { SOUND_ID_STOP } from "../Reducer/soundIDSlice";
import { CLUSTER_FETCH_SUCCESS } from "../Reducer/ClusterSlice";
import isTenantUser from "../CustomHook/tenantUser";

export default function Nav() {
  const dispatch = useDispatch();
  const location = useLocation();
  const [data_menu, setDataMenu] = useState([]);
  const [active_menu, setActiveMenu] = useState(false);

  const selector = useSelector((state) => state.siteIdReducer)
  const selector_batteryId = useSelector((state) => state.batteryIDReducer)
  const selector_acmId = useSelector((state) => state.acmIDReducer)
  const selector_recId = useSelector((state) => state.rectifierIDReducer)
  const selector_offlineID = useSelector((state) => state.offlineIDReducer)
  const { user: profileUser } = useSelector((state) => state.profileReducer);
  const { user: authUser } = useSelector((state) => state.authReducer);
  const tenantUser = isTenantUser(profileUser?.id ? profileUser : authUser);
  const [modalDialog, setModalDialog] = useState(false);
  const rmsAlarmID = useSelector((state) => state.rmsAlarmIdReducer)
  const ddd = useParams();

  const [search, setSearch] = useState('');
  const [filtered, setFiltered] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [openSubmenuIndex, setOpenSubmenuIndex] = useState(null);


  const toggleModal = () => {
    setModalDialog(!modalDialog)
  }

  const ToggleSwitch = () => (
    setActiveMenu(!active_menu)
  )


  if (active_menu) {
    document.body.classList.add(
      'offcanvas-active'
    );
  } else {
    if (document.body.classList.contains('offcanvas-active')) {
      document.body.classList.remove('offcanvas-active');
    }
  }

  const _logout = () => {
    API.get(`/v1/oauth/logout`)
      .then(res => {
        if (res.data.success === true) {
          localStorage.clear();
        }
      })
    localStorage.clear();
    window.location.href = '/';
  }

  const _get_menu = () => {
    API.get(`/v1/oauth/get_menu`)
      .then(res => {
        setDataMenu(res.data.data.menus)
      })

  }

  const get_cluster = () => {
    API.get(`/v1/oauth/clusters`)
      .then(res => {
        dispatch(CLUSTER_FETCH_SUCCESS(res.data.data))
      })

  }
  
  const get_sites = (siteId) => {
    setSearch(siteId);
    if (siteId.length > 0) {

      API.get(`/v1/oauth/all_sites?site_id=${siteId}`)
        .then(res => {

          setFiltered(res.data.data.sites);
          setShowDropdown(true);
        }).catch((error) => {
          setFiltered([]);
          setShowDropdown(false);
          setSearch('')
        });
    } else {
      setFiltered([]);
      setShowDropdown(false);
      setSearch('')
    }
  }

  const clear_sites = () => {
    setFiltered([]);
    setShowDropdown(false);
    setSearch('')
  }

  const _profile = () => {
    API.get(`/v1/oauth/my_profile`)
      .then(res => {
        dispatch(USER_FETCH_START(res.data.data))
        const auth = JSON.parse(localStorage.getItem("auth") || "{}");
        if (auth?.accessToken && res.data?.data?.user) {
          const nextAuth = { ...auth, user: res.data.data.user };
          localStorage.setItem("auth", JSON.stringify(nextAuth));
          dispatch(USER_LOGGED_IN({ user: res.data.data.user, accessToken: auth.accessToken }));
        }
      }).catch((error) => {
        if (error.response.status == 401 && error.response.statusText == "Unauthorized") {
          localStorage.clear();
          window.location.href = '/';
        }
      });

  }

  useEffect(() => {
    _get_menu()
    _profile()
   // get_cluster()
  //  dispatch(RMS_STATION_FETCH_START());
    Agent.Notification.latest(dispatch);
    // Agent.All_RMS.all(dispatch);
    // Agent.RMS_ALARM.nav(dispatch);
    // Agent.All_RMS_STATUS.all(dispatch);
    Agent.HOME.sync_tenants(dispatch);
  
    
  }, []);

  const handleNotificationView = () => {
    Agent.Notification.readAll();
    Agent.Notification.latest(dispatch);
  }

  const stopSound = () => {
    dispatch(SOUND_ID_STOP())
  }

  const navigate = useNavigate();
  const notificationData = useSelector((state) => state.notifyReducer?.data)
  const sound_selector = useSelector((state) => state.soundReducer);

  const handleSelect = (item) => {
    setSearch('');
    setShowDropdown(false);
    navigate(`/site/${encodeURIComponent(item)}`);
  };

  const handleSubmenuClick = (e, index) => {
    if (window.innerWidth <= 768) {
      e.preventDefault();
      e.stopPropagation();
      setOpenSubmenuIndex(openSubmenuIndex === index ? null : index);
    } else {
      e.preventDefault();
    }
  };

  const closeMenuDropdown = () => {
    setOpenSubmenuIndex(null);
  };

  

  // selector?.data

  // useEffect(() => {

  //   if (selector?.data != null) {

  //     API.get('/v1/oauth/site/' + selector?.data).then((response) => {
  //       dispatch(DOOR_DASHBOARD_FETCH_SUCCESS(response.data.data.rms.site))
  //       dispatch(SITE_DASHBOARD_FETCH_SUCCESS({
  //         siteId: selector?.data,
  //         payload: response.data.data.rms
  //       }));
  //     }).catch((error) => {

  //     });

  //   }

  // }, [selector?.data]);



  return (
    <>
      <nav className="navbar navbar-expand-lg p-0 navbar-custom" id="page_top">
        <div className="container-fluid">
          <div className="page-header w-100">
            <div className="left">
              {location.pathname == '/agent' || location.pathname.startsWith('/map')|| location.pathname.startsWith('/all_notifications') || location.pathname.startsWith('/site_down_history') || location.pathname.startsWith('/rms_alarm_filter') || location.pathname.startsWith('/acs_alarm_filter') || location.pathname == '/roles' || location.pathname == '/users' ||  location.pathname == '/functional_dashboard' || location.pathname == '/business_dashboard' || location.pathname == '/acm-monitoring' || location.pathname == '/login-information' || location.pathname == '/password-change' || location.pathname == '/notification_setting' || location.pathname == '/ai-provider' || location.pathname == '/organisation_users' || location.pathname == '/reports' || location.pathname == '/access_permission' || location.pathname == '/organisations' || location.pathname == '/all_doors' || location.pathname == '/all_jobs' || location.pathname == '/issues' || location.pathname == '/rms_stations' || location.pathname == '/rectifier_monitoring' || location.pathname == '/timeline' || location.pathname == '/alarms' || location.pathname == '/rms_alarms' || location.pathname == '/all_sites' || location.pathname == '/offline_sites' || location.pathname == '/offline_sites/' + selector_offlineID.data || location.pathname == '/online_sites' || location.pathname == '/dc_energy' || location.pathname == '/rectifier_alarm_history' || location.pathname == '/rectifier_live_alarm'  ? <Link onClick={() => navigate(-1)}><i className="fa-duotone fa-arrow-left me-1"></i></Link> : location.pathname == '/' ? <i className="fa-light fa-grid-2 me-1"></i> :
                <a href="#" className="nav-link icon menu_toggle" onClick={() => ToggleSwitch()}><i className="fa-light fa-align-left" /></a>
              }
              <div className="page-title">
                {location.pathname == '/agent' ? 'AI Agent' : location.pathname.startsWith('/site_down_history') ?'Site Down History':location.pathname.startsWith('/rms_alarm_filter') ? 'RMS Active Alarm' :  location.pathname.startsWith('/acs_alarm_filter')?'ACS Active Alarm': location.pathname == '/roles' ? 'Roles' : location.pathname == '/users' ? 'User Management' : location.pathname == '/business_dashboard' ? 'Business Dashboard' : location.pathname == '/functional_dashboard' ? 'Functional Dashboard' : location.pathname == '/acm-monitoring' ? 'AC Energy Meter' : location.pathname == '/login-information' ? 'Login Information' : location.pathname == '/password-change' ? 'Change Password' : location.pathname == '/ai-provider' ? 'AI Provider' : location.pathname == '/notification_setting' ? 'Notification Settings' : location.pathname == '/reports' ? 'Report' : location.pathname == '/access_permission' ? 'Access Permission' : location.pathname == '/organisation_users' ? 'Vendor Users' : location.pathname == '/organisations' ? 'Organisations' : location.pathname == '/all_doors' ? 'All Doors' : location.pathname == '/all_jobs' ? 'Job Management' : location.pathname == '/issues' ? 'Issues' : location.pathname == '/rms_stations' ? 'RMS Stations' : location.pathname == '/rectifier_monitoring' ? 'Rectifier monitoring' : location.pathname == '/offline_sites' || location.pathname == '/offline_sites/' + selector_offlineID.data ? 'Offline Sites' : location.pathname == '/online_sites' ? 'Online Sites' : location.pathname == '/all_sites' ? 'All Sites' : location.pathname == '/dc_energy' ? 'DC Energy Meter' : location.pathname === '/' ? 'Dashboard (RMS & Access Control)' : location.pathname === '/timeline' ? 'Timeline' : location.pathname === '/alarms' ? 'ACS Alarm Histroy' : location.pathname === '/rms_alarms' ? 'RMS Alarm Histroy' : location.pathname === '/site/' + selector?.data + '/alarms' ? <span>Alarms History (<span className="font-11">Site ID:{selector?.data}</span>)</span> : location.pathname === '/site/' + selector?.data + '/bms' ? <span>Battery (<span className="font-11">Site ID:{selector?.data}</span>)</span> : location.pathname === '/site/' + selector?.data + '/bms/' + selector_batteryId?.data + '/dashboard' || location.pathname === '/site/' + selector?.data + '/bms/' + selector_batteryId?.data + '/cell_monitoring' || location.pathname === '/site/' + selector?.data + '/bms/' + selector_batteryId?.data + '/graph' ? <span><Link to={'/site/' + selector?.data + '/bms'} ><i className="fa-duotone fa-arrow-left me-2" /></Link>Battery (<span className="font-11">SL NO:{selector_batteryId?.data}</span>) (<span className="font-11">Site ID:{selector?.data}</span>)</span> : location.pathname === '/site/' + selector?.data + '/alarms/rms' ? <span>Alarm History (<span className="font-11">Site ID:{selector?.data}</span>)</span> : location.pathname === '/site/' + selector?.data ? <span>Site Overview (<span className="font-11">Site ID:{selector?.data}</span>)</span> : location.pathname === '/site/' + selector?.data + '/dc_energy_meter' || location.pathname === '/site/' + selector?.data + '/dc_energy_meter/graph' || location.pathname === '/site/' + selector?.data + '/dc_energy_meter/dc_consumption' || location.pathname === '/site/' + selector?.data + '/dc_energy_meter/dc_tenant' || location.pathname === '/site/' + selector?.data + '/dc_energy_meter/load_disconnect' || location.pathname === '/site/' + selector?.data + '/dc_energy_meter/overload' ? <span>DC Energy Meter (<Link to={`/site/${selector?.data}`} className="font-11">Site ID:{selector?.data}</Link>)</span> : location.pathname === '/site/' + selector?.data + '/pg' ? <span>PG/DG Monitoring (<Link to={`/site/${selector?.data}`} className="font-11">Site ID:{selector?.data}</Link>)</span> : location.pathname === '/site/' + selector?.data + '/ac_energy_meter/' + selector_acmId.data || location.pathname === '/site/' + selector?.data + '/ac_energy_meter/' + selector_acmId.data + '/graph' || location.pathname === '/site/' + selector?.data + '/ac_energy_meter/' + selector_acmId.data + '/report' ? <span>AC Energy Meter (<Link to={`/site/${selector?.data}`} className="font-11">Site ID:{selector?.data}</Link>)</span> : location.pathname === '/site/' + selector?.data + '/assets' ? <span>Site Assets (<Link to={`/site/${selector?.data}`} className="font-11">Site ID:{selector?.data}</Link>)</span> : (location.pathname === '/site/' + selector?.data + '/configuration' || location.pathname === `/site/${ddd.id}/configuration`) ? <span>Configuration (<span className="font-11">Site ID:{selector?.data || ddd.id}</span>)</span> : location.pathname === '/site/' + selector?.data + '/rectifier/' + selector_recId.data || location.pathname === '/site/' + selector?.data + '/rectifier/' + selector_recId.data + '/report' || location.pathname === '/site/' + selector?.data + '/rectifier/' + selector_recId.data + '/graph' ? <span>Rectifier Monitoring (<Link to={`/site/${selector?.data}`} className="font-11">Site ID:{selector?.data}</Link>)</span> : location.pathname === '/site/' + selector?.data + '/temperature' ? <span>Temperature (<span className="font-11">Site ID:{selector?.data}</span>)</span> : (location.pathname == '/rectifier_alarm_history'?'Rectifier Alarm History':(location.pathname == '/rectifier_live_alarm'?'Rectifier Active Alarm':(location.pathname =='/map'?'Map':(location.pathname.startsWith('/all_notifications')?'Notifications':'Dashboard'))))}
              </div>



            </div>
            <div className={`nav-site-search-wrap position-relative center ${location.pathname == '/' || location.pathname == '/business_dashboard' ? 'd-block' : 'd-none'}`}>
              <div className="nav-site-search">
                <span className="nav-site-search-icon">
                  <i className="fa-light fa-magnifying-glass" />
                </span>
                <input
                  value={search}
                  onChange={(e) => get_sites(e.target.value)}
                  type="text"
                  className="nav-site-search-input"
                  placeholder="Search site ID..."
                />
                {search && (
                  <button type="button" className="nav-site-search-clear" onClick={() => clear_sites()} aria-label="Clear search">
                    <i className="fa-solid fa-xmark" />
                  </button>
                )}
              </div>
              {showDropdown && filtered.length > 0 && (
                <ul className="nav-site-search-dropdown">
                  {filtered.map((item, idx) => (
                    <li
                      key={idx}
                      className="nav-site-search-item"
                      onClick={() => handleSelect(item.site_id)}
                    >
                      <i className="fa-regular fa-signal nav-site-search-item-icon" />
                      <span>{item.site_id}</span>
                    </li>
                  ))}
                </ul>
              )}
            </div>
            <div className="right">

              <div className="navbar-collapse" id="main_nav">
                <ul className="navbar-nav tree-menu align-items-center">
                    {!tenantUser && location.pathname == '/' && location.pathname != '/functional_dashboard' ?
                      <li className="nav-item nav-dashboard-btn me-2 mb-0" role="presentation">
                        <Link to={`/functional_dashboard`} className="atc-btn sm" role="tab" aria-controls="pills-contact" aria-selected="false">Functional Dashboard</Link>
                      </li>
                      : !tenantUser && location.pathname == '/functional_dashboard' ?
                      <li className="nav-item nav-dashboard-btn me-2 mb-0" role="presentation">
                        <Link to={`/`} className="atc-btn sm" role="tab" aria-controls="pills-contact" aria-selected="false">Noc Dashboard</Link>
                      </li>
                      : null
                    }

                  <li className="nav-item dropdown nav-main-menu" id="myDropdown">
                    <a className="nav-menu-trigger dropdown-toggle" href="#" data-bs-toggle="dropdown" aria-expanded="false">
                      <span className="nav-menu-trigger-icon">
                        <i className="fa-regular fa-bars-staggered" />
                      </span>
                      <span className="nav-menu-trigger-text">Menu</span>
                      <i className="fa-solid fa-chevron-down nav-menu-trigger-chevron" />
                    </a>
                    <ul className="dropdown-menu dropdown-menu-end nav-menu-dropdown animate">
                      <li className="nav-menu-dropdown-header">
                        <i className="fa-light fa-compass" />
                        <span>Quick Navigation</span>
                      </li>
                      <li className="d-none">
                        <Link className="dropdown-item nav-menu-link" to="/agent" onClick={closeMenuDropdown}>
                          <i className="fa-light fa-circle nav-menu-link-icon" />
                          <span>AI Agent</span>
                        </Link>
                      </li>

                      {data_menu.length > 0 && data_menu.map((row, index) => (
                        row.submenus?.length <= 0 ? (
                          <li key={index}>
                            <Link className="dropdown-item nav-menu-link" to={row.path} onClick={closeMenuDropdown}>
                              <i className="fa-light fa-circle nav-menu-link-icon" />
                              <span>{row.title}</span>
                            </Link>
                          </li>
                        ) : (
                          <li
                            key={index}
                            className={`nav-menu-item has-submenu ${openSubmenuIndex === index ? 'submenu-open' : ''}`}
                          >
                            <a
                              className="dropdown-item nav-menu-link nav-menu-parent"
                              href="#"
                              onClick={(e) => handleSubmenuClick(e, index)}
                            >
                              <i className="fa-light fa-folder nav-menu-link-icon" />
                              <span>{row.title}</span>
                              <i className="fa-solid fa-chevron-right nav-menu-chevron" />
                            </a>
                            <ul className="submenu dropdown-menu nav-menu-submenu">
                              {row.submenus.map((srow, k) => (
                                <li key={k}>
                                  <Link className="dropdown-item nav-menu-link nav-menu-sublink" to={srow.path} onClick={closeMenuDropdown}>
                                    <i className="fa-light fa-angle-right nav-menu-sublink-icon" />
                                    <span>{srow.title}</span>
                                  </Link>
                                </li>
                              ))}
                            </ul>
                          </li>
                        )
                      ))}
                    </ul>
                  </li>
                </ul>
                <div className="notification d-flex">
                  <div className="dropdown d-flex">
                    <Link to={`/`} className="nav-link icon d-md-flex btn btn-default btn-icon  dropdown-toggle" type="button" >
                      <i className="fa-light fa-home"></i>
                    </Link>

                  </div>

                  <div className="dropdown d-flex">
                    <a className="nav-link icon d-md-flex btn btn-default btn-icon  dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                      <i className="fa-duotone fa-bell" />
                      <span className="badge bg-danger nav-unread">{notificationData?.total_count}</span>

                    </a>
                    <div className="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
                      <ul className="list-unstyled feeds_widget">
                        {notificationData.notification?.map((value, index) => (
                          <li key={index} className={` ${value.read_at == null ? "notification-unseen-color" : ""}`}>
                            <div className="feeds-left"><i className="fal fa-bell" /></div>
                            <div className="feeds-body">
                              <h4 className="title">{value.title}<small className="float-end text-muted fs-11">{value.alarm_start}</small></h4>
                              <small>{value.body}</small>
                            </div>
                          </li>
                        ))}
                      </ul>
                      <div className="dropdown-divider" />
                      <a href="#"
  onClick={(e) => {
    e.preventDefault();
    handleNotificationView();
  }} className="dropdown-item text-center text-muted-dark readall">Mark all as read</a>
                                           <Link to={`/all_notifications`} className="dropdown-item text-center text-muted-dark readall">See all</Link>

                    </div>
                  </div>
                  <div className="dropdown d-flex">
                    <a className="nav-link icon d-md-flex btn btn-default btn-icon dropdown-toggle p-0 ms-2 user-setting" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                      <img className="avatar" src="/assets/image/avatar.png" alt="" />
                    </a>
                    <div className="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
                      <a className="dropdown-item" href="#" onClick={() => toggleModal(true)} key={`n4`}><i className="dropdown-icon fal fa-cog" /> Profile</a>
                      <Link className="dropdown-item" to={`notification_setting`} key={`n0`}><i className="dropdown-icon fal fa-cog" /> Notification Settings</Link>
                      <Link className="dropdown-item" to={`/ai-provider`} key={`ai`}><i className="dropdown-icon fal fa-cog" /> AI Provider</Link>
                      <div className="dropdown-divider" />
                       <a href="#" onClick={() => stopSound()} className="dropdown-item" key={`n1`}>
                        {sound_selector?.loading ?

                          <i class="fa-solid fa-volume-slash dropdown-icon" />
                          :
                          <i class="fa-solid fa-volume-high dropdown-icon" />
                        } Stop Sound

                      </a>
                      <Link className="dropdown-item" to={`password-change`} key={`n2`}><i className="dropdown-icon fal fa-question-circle" /> Password change?</Link>
                      <a className="dropdown-item" href="#" onClick={() => _logout()} key={`n3`}><i className="dropdown-icon fal fa-power-off" /> Sign out</a>
                     
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>
      <DashboardSettingModel isModalVisible={modalDialog} handleShowB={() => setModalDialog(false)} />
    </>
  )
}